(function () {
  "use strict";

  function withSwiper(callback) {
    if (!window.HaloSwiperLoader) return Promise.resolve();
    return window.HaloSwiperLoader.ensure().then(callback);
  }

  function getCartCarouselArrows() {
    if (window.arrows && window.arrows.icon_next && window.arrows.icon_prev) {
      return {
        icon_next: window.arrows.icon_next.replace(
          'class="slick-next"',
          'class="slick-arrow slick-next"'
        ),
        icon_prev: window.arrows.icon_prev.replace(
          'class="slick-prev"',
          'class="slick-arrow slick-prev"'
        ),
      };
    }

    return {
      icon_next:
        '<button type="button" aria-label="Next slide" class="slick-arrow slick-next"></button>',
      icon_prev:
        '<button type="button" aria-label="Previous slide" class="slick-arrow slick-prev"></button>',
    };
  }

  function prepareCartCarouselElement(el, controlsRoot, itemArrows) {
    if (el.swiper) return el;

    el.classList.add("swiper", "halo-swiper-carousel", "previewCartCarousel--swiper");

    if (!el.querySelector(".swiper-wrapper")) {
      var wrapper = document.createElement("div");
      wrapper.className = "swiper-wrapper";
      while (el.firstChild) {
        var child = el.firstChild;
        if (child.nodeType === 1) {
          child.classList.add("swiper-slide");
          wrapper.appendChild(child);
        } else {
          child.remove();
        }
      }
      el.appendChild(wrapper);
    }

    if (itemArrows && !controlsRoot.querySelector(".slick-next")) {
      var arrows = getCartCarouselArrows();
      controlsRoot.insertAdjacentHTML("beforeend", arrows.icon_prev);
      controlsRoot.insertAdjacentHTML("beforeend", arrows.icon_next);
    }

    if (!controlsRoot.querySelector(".swiper-pagination")) {
      controlsRoot.insertAdjacentHTML(
        "beforeend",
        '<div class="swiper-pagination"></div>'
      );
    }

    return el;
  }

  function initProductCartCarouselCore() {
    if (!window.Swiper || !window.jQuery) return;

    window.jQuery("[data-product-collection-cart]").each(function (_, block) {
      var $grid = window.jQuery(block).find(".products-carousel");
      if (!$grid.length || $grid[0].swiper) return;

      var el = $grid[0];
      var controlsRoot = block;
      var itemDots = $grid.data("item-dots");
      var itemArrows = $grid.data("item-arrows");

      prepareCartCarouselElement(el, controlsRoot, itemArrows);

      var paginationEl = controlsRoot.querySelector(".swiper-pagination");
      var nextEl = controlsRoot.querySelector(".slick-next");
      var prevEl = controlsRoot.querySelector(".slick-prev");

      new window.Swiper(el, {
        slidesPerView: 1,
        slidesPerGroup: 1,
        watchOverflow: true,
        navigation: itemArrows
          ? {
              nextEl: nextEl,
              prevEl: prevEl,
            }
          : false,
        pagination: {
          el: paginationEl,
          clickable: true,
        },
        breakpoints: {
          1280: {
            pagination: {
              el: paginationEl,
              clickable: true,
              enabled: itemDots !== false,
            },
          },
        },
      });
    });
  }

  window.HaloSwiperCarousels = {
    initProductCartCarousel: function () {
      return withSwiper(initProductCartCarouselCore);
    },
  };
})();
